/*
  ============================================================
  COVER YOU — Nom de la marque protégé de la traduction
  Asset : assets/cy-notranslate.js (chargé par snippets/cy-custom-styles.liquid)
  Objectif : quand un visiteur fait traduire la page (Chrome, Google
             Traduction, Edge…), « COVER YOU » reste « COVER YOU ».
             Chaque occurrence est enveloppée dans
             <span translate="no" class="notranslate">, que ces outils
             respectent. Le reste de la page se traduit normalement.
             Les contenus ajoutés plus tard (tiroir panier, recherche,
             sections rechargées) sont traités aussi.
  Date : 31-10-26 — Version : 1.0
  ROLLBACK : retirer la ligne <script … cy-notranslate.js> de
             snippets/cy-custom-styles.liquid, puis supprimer ce fichier.
  ============================================================
*/
(() => {
  const BRAND = /cover\s+you/i;
  const BRAND_ALL = /cover\s+you/gi;
  const SKIP = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'SELECT', 'OPTION', 'TITLE', 'SVG', 'CODE']);

  function protect(textNode) {
    const text = textNode.nodeValue;
    if (!text || !BRAND.test(text)) return;
    const parent = textNode.parentElement;
    if (!parent || SKIP.has(parent.tagName.toUpperCase()) || parent.isContentEditable) return;
    if (parent.closest('[translate="no"], .notranslate')) return;

    const frag = document.createDocumentFragment();
    let last = 0;
    text.replace(BRAND_ALL, (match, offset) => {
      if (offset > last) frag.appendChild(document.createTextNode(text.slice(last, offset)));
      const span = document.createElement('span');
      span.setAttribute('translate', 'no');
      span.className = 'notranslate';
      span.textContent = match;
      frag.appendChild(span);
      last = offset + match.length;
      return match;
    });
    if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
    textNode.replaceWith(frag);
  }

  function scan(root) {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) { protect(root); return; }
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (n) => (BRAND.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT)
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(protect);
  }

  function start() {
    scan(document.body);
    let pending = [];
    let scheduled = false;
    new MutationObserver((records) => {
      records.forEach((r) => r.addedNodes.forEach((n) => pending.push(n)));
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        const batch = pending;
        pending = [];
        scheduled = false;
        batch.forEach((n) => { if (n.isConnected) scan(n); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
